export enum AssetRepairStatus {
  WaitingForRepair = 'waiting_for_repair',
  Done = 'done',
  Canceled = 'canceled',
}
